.icon {
  display: inline-flex;
  align-items: center;
  color: var(--icon-color, var(--text-color));
  user-select: none;
}
